import { Box, Button, Typography } from '@mui/material';
import { Unity, useUnityContext } from "react-unity-webgl";
import React, { useEffect, useState } from 'react';

const UnityVisualization = () => {
    const [referenceFile, setReferenceFile] = useState(null);

    //const { unityProvider, sendMessage } = useUnityContext({
    //    loaderUrl: "unityVisualization/BuildTest16/Build/BuildTest16.loader.js",
    //    dataUrl: "unityVisualization/BuildTest16/Build/BuildTest16.data.unityweb",
    //    workerUrl: "unityVisualization/BuildTest16/Build/BuildTest16.data.unityweb",
    //    frameworkUrl: "unityVisualization/BuildTest16/Build/BuildTest16.framework.js.unityweb",
    //    codeUrl: "unityVisualization/BuildTest16/Build/BuildTest16.wasm.unityweb",
    //});
    const { unityProvider, sendMessage } = useUnityContext({
        loaderUrl: "unityVisualization/2025_06_24_coloration_fixes/Build/2025_06_24_coloration_fixes.loader.js",
        dataUrl: "unityVisualization/2025_06_24_coloration_fixes/Build/2025_06_24_coloration_fixes.data.unityweb",
        workerUrl: "unityVisualization/2025_06_24_coloration_fixes/Build/2025_06_24_coloration_fixes.data.unityweb",
        frameworkUrl: "unityVisualization/2025_06_24_coloration_fixes/Build/2025_06_24_coloration_fixes.framework.js.unityweb",
        codeUrl: "unityVisualization/2025_06_24_coloration_fixes/Build/2025_06_24_coloration_fixes.wasm.unityweb",
    });
    //const { unityProvider, sendMessage } = useUnityContext({
    //    loaderUrl: "unityVisualization/U9/Build/U9.loader.js",
    //    dataUrl: "unityVisualization/U9/Build/U9.data.unityweb",
    //    workerUrl: "unityVisualization/U9/Build/U9.data.unityweb",
    //    frameworkUrl: "unityVisualization/U9/Build/U9.framework.js.unityweb",
    //    codeUrl: "unityVisualization/U9/Build/U9.wasm.unityweb",
    //});

    const handleHackTextDisplay = () => {
        sendMessage("Sphere", "Hack_Text_Display", "SomethingSomething");
    }

    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box>
                    <Typography variant="h6">Unity Visualization</Typography>
                </Box>
                <Button variant="contained" onClick={handleHackTextDisplay}>Hack Text Display</Button>
            </Box>
            <span style={{ marginLeft: "10px", width: '70%', float: 'left', height: 600, borderStyle: "solid", borderWidth: "2px" }}>
                <Unity unityProvider={unityProvider} style={{ width: '100%', height: '100%' }} />
            </span>
            <span style={{ marginLeft: "10px", width: '25%', float: 'left' }}>
                <b>User Controls</b><br />
                Navigation: <i>(A,S,W,D)</i><br />
                Zoom/Rotate: <i>Arrow Keys</i><br />
                Alter Speed: <i>Tap R, type in value</i><br />
                Scrub Backward/Forwards: <i>(J, K)</i><br />
                Pause/Play: <i>P</i><br />
                Jump to Time Point: <i>Tap T, enter numbers</i><br />

                 
            </span>
        </div>
    )
}

export default UnityVisualization;